
import { BASE_URL } from '../../utils/const';
import http from '../httpService';

export function getRiskTypes() {
  return http.get(`${BASE_URL}/risk-types?id.notEquals=3`);
}

export function getDepartments() {
  return http.get(`${BASE_URL}/departments`);
}

export function getRole() {
  return http.get(`${BASE_URL}/account`);
}

export function getUserDepartment() {
  return http.get(`${BASE_URL}/departments-login-user`);
}
